<template/>
<script>
export default {
  data() {
    let vm = this;
    return {
      element: null,
      resources: {
        zIndex: {
          name: 'zIndex',
          defaultValue: '',
          labelDesc: 'zIndex',
          callback: function() {
            vm.resources.zIndex.defaultValue = this.value;
            vm.element.internal_config.zIndex = this.value;

          }
        },
        maxWidth: {
          name: 'maxWidth',
          defaultValue: '500',
          min: '200',
          max: '768',
          labelDesc: 'max-width-tablet',
          callback: function() {
            vm.resources.maxWidth.defaultValue = this.value;
            vm.element.internal_config.maxWidth = this.value + 'px';

            vm.element.buildFields(vm.element);

          },
        },
        // horizontal: {
        //   name: 'horizontal',
        //   defaultValue: false,
        //   labelDesc: 'horizontal-form',
        //   callback: function() {
        //     vm.resources.horizontal.defaultValue = this.value;
        //     vm.element.internal_config.horizontal = this.value;
        //
        //     vm.element.buildFields(vm.element);
        //   }
        // },

        showLabel: {
          name: 'showLabel',
          defaultValue: '',
          labelDesc: 'show-label',
          callback: function() {
            vm.resources.showLabel.defaultValue = this.value;
            vm.element.internal_config.showLabel = this.value;

            vm.element.buildFields(vm.element);
          }
        },
        showTitle: {
          name: 'showTitle',
          defaultValue: '',
          labelDesc: 'show-title',
          callback: function() {
            vm.resources.showTitle.defaultValue = this.value;
            vm.element.internal_config.form.showTitle = this.value;

            vm.element.buildFields(vm.element);
          }
        },
        showDescription: {
          name: 'showDescription',
          defaultValue: '',
          labelDesc: 'show-description',
          callback: function() {
            vm.resources.showDescription.defaultValue = this.value;
            vm.element.internal_config.form.showDescription = this.value;

            vm.element.buildFields(vm.element);
          }
        },
        showPreviousButton: {
          name: 'showPreviousButton',
          defaultValue: '',
          labelDesc: 'show-previous-button',
          callback: function() {
            vm.resources.showPreviousButton.defaultValue = this.value;
            vm.element.internal_config.form.showPreviousButton = this.value;

            vm.element.buildFields(vm.element);
          }
        },
        showPlaceholder: {
          name: 'showPlaceholder',
          defaultValue: '',
          labelDesc: 'show-placeholder',
          callback: function() {
            vm.resources.showPlaceholder.defaultValue = this.value;
            vm.element.internal_config.showPlaceholder = this.value;

            vm.element.buildFields(vm.element);
          }
        },
        text: {
          name: 'text',
          defaultValue: '',
          labelDesc: 'text-submit',
          canRemove: false,
          callback: function() {
            vm.resources.text.defaultValue = this.value;
            vm.element.internal_config.button.text = this.value;

            vm.element.internal_config.button.backgroundColor = vm.resources.backgroundColor.defaultValue;

            vm.element.buildFields(vm.element);
          }
        },
        subText: {
          name: 'subtext',
          defaultValue: '',
          labelDesc: 'subtext-submit',
          canRemove: false,
          callback: function() {
            vm.resources.subText.defaultValue = this.value;
            vm.element.internal_config.button.subText = this.value;
            vm.element.internal_config.button.subText = this.value;

            vm.element.internal_config.button.backgroundColor = vm.resources.backgroundColor.defaultValue;

            vm.element.buildFields(vm.element);
          }
        },
        border: {
          name: 'border',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'border-submit',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.border.defaultValue = value;
            vm.element.internal_config.button.border = value;

            vm.element.buildFields(vm.element);
          }
        },
        borderRadius: {
          name: 'borderRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'borderRadius-submit',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadius.defaultValue = value;
            vm.element.internal_config.button.borderRadius = value;

            vm.element.buildFields(vm.element);
          }
        },
        inputRadius: {
          name: 'inputRadius',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'inputRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.inputRadius.defaultValue = value;
            vm.element.internal_config.inputRadius = value;

            vm.element.inputStyle();
          }
        },
        backgroundColor: {
          name: 'backgroundColor',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color-submit',
          callback: function() {
            vm.resources.backgroundColor.defaultValue = this.colorValue;
            vm.element.internal_config.button.backgroundColor = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        inputBorder: {
          name: 'inputBorder',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'input-border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.inputBorder.defaultValue = value;
            vm.element.internal_config.inputBorder = value;

            vm.element.inputStyle();
          }
        },
        inputColor: {
          name: 'inputColor',
          defaultValue: '#ffffff',
          labelDesc: 'input-bg-color',
          callback: function() {
            vm.resources.inputColor.defaultValue = this.colorValue;
            vm.element.internal_config.inputBgColor = this.colorValue;

            vm.element.inputStyle();
          }
        },
        labelStyle: {
          name: 'labelStyle',
          defaultValue: '#ffffff',
          labelDesc: 'input-label-color',
          callback: function() {
            vm.resources.labelStyle.defaultValue = this.colorValue;
            vm.element.internal_config.labelStyle = this.colorValue;

            vm.element.inputStyle();
          }
        },
        placeholderColor: {
          name: 'placeholderColor',
          defaultValue: '#5c5c5c',
          labelDesc: 'placeholder-color',
          callback: function() {
            vm.resources.placeholderColor.defaultValue = this.colorValue;
            vm.element.internal_config.placeholderColor = this.colorValue;
            vm.element.placeholderStyle();
          }
        },
        inputHeight: {
          name: 'inputHeight',
          defaultValue: '38',
          min: '5',
          max: '100',
          labelDesc: 'input-height',
          callback: function() {
            vm.resources.inputHeight.defaultValue = this.value;
            vm.element.internal_config.inputHeight = this.value + 'px';

            vm.element.inputStyle();
          }
        },
        textareaHeight: {
          name: 'textareaHeight',
          defaultValue: '54',
          min: '5',
          max: '300',
          labelDesc: 'textarea-height',
          callback: function() {
            vm.resources.textareaHeight.defaultValue = this.value;
            vm.element.internal_config.textareaHeight = this.value + 'px';

            vm.element.inputStyle();
          }
        },
        buttonMargin: {
          name: 'buttonMargin',
          defaultValue: '15',
          min: '0',
          max: '100',
          labelDesc: 'button-margin-submit',
          callback: function() {
            vm.resources.buttonMargin.defaultValue = this.value;
            vm.element.internal_config.button.margin = this.value;

            vm.element.buildFields(vm.element);
          }
        },
        backgroundColorHover: {
          name: 'backgroundColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color-hover-submit',
          callback: function() {
            vm.resources.backgroundColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.button.backgroundColorHover = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        textColorHover: {
          name: 'textColorHover',
          defaultValue: '#ffffff',
          labelDesc: 'bg-color-text-hover-submit',
          callback: function() {
            vm.resources.textColorHover.defaultValue = this.colorValue;
            vm.element.internal_config.button.textColorHover = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        boxShadow: {
          name: 'boxShadow',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'boxShadow-submit',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            console.log(value);

            vm.resources.boxShadow.defaultValue = value;
            vm.element.internal_config.button.boxShadow = value;

            vm.element.buildFields(vm.element);
          }
        },
        icon: {
          name: 'icon',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'icon-submit',
          callback: function() {
            vm.resources.icon.defaultIcon = this.iconSelected;
            vm.resources.icon.defaultPosition = this.position;

            vm.element.internal_config.button.icon = this.iconSelected;
            vm.element.internal_config.button.iconPosition = this.position;

            vm.element.buildIcon();
          }
        },
        titleFormStyle: {
          name: 'titleFormStyle',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'titleFormStyle-submit',
          callback: function() {
            vm.resources.titleFormStyle.defaultFamily = this.family;
            vm.element.internal_config.titleFormStyle.family = this.family;

            vm.resources.titleFormStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.titleFormStyle.size = this.size + 'px';

            vm.resources.titleFormStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.titleFormStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.titleFormStyle.defaultColor = this.color;
            vm.element.internal_config.titleFormStyle.color = this.color;

            vm.resources.titleFormStyle.defaultAlign = this.align;
            vm.element.internal_config.titleFormStyle.align = this.align;

            vm.resources.titleFormStyle.defaultWeight = this.weight;
            vm.element.internal_config.titleFormStyle.weight = this.weight;

            vm.resources.titleFormStyle.defaultStyle = this.style;
            vm.element.internal_config.titleFormStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        descriptionFormStyle: {
          name: 'descriptionFormStyle',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'descriptionFormStyle-submit',
          callback: function() {
            vm.resources.descriptionFormStyle.defaultFamily = this.family;
            vm.element.internal_config.descriptionFormStyle.family = this.family;

            vm.resources.descriptionFormStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.descriptionFormStyle.size = this.size + 'px';

            vm.resources.descriptionFormStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.descriptionFormStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.descriptionFormStyle.defaultColor = this.color;
            vm.element.internal_config.descriptionFormStyle.color = this.color;

            vm.resources.descriptionFormStyle.defaultAlign = this.align;
            vm.element.internal_config.descriptionFormStyle.align = this.align;

            vm.resources.descriptionFormStyle.defaultWeight = this.weight;
            vm.element.internal_config.descriptionFormStyle.weight = this.weight;

            vm.resources.descriptionFormStyle.defaultStyle = this.style;
            vm.element.internal_config.descriptionFormStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        textStyle: {
          name: 'textStyle',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'textStyle-submit',
          callback: function() {
            vm.resources.textStyle.defaultFamily = this.family;
            vm.element.internal_config.button.textStyle.family = this.family;

            vm.resources.textStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.button.textStyle.size = this.size + 'px';

            vm.resources.textStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.button.textStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.textStyle.defaultColor = this.color;
            vm.element.internal_config.button.textStyle.color = this.color;

            vm.resources.textStyle.defaultAlign = this.align;
            vm.element.internal_config.button.textStyle.align = this.align;

            vm.resources.textStyle.defaultWeight = this.weight;
            vm.element.internal_config.button.textStyle.weight = this.weight;

            vm.resources.textStyle.defaultStyle = this.style;
            vm.element.internal_config.button.textStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        subTextStyle: {
          name: 'subTextStyle',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          labelDesc: 'subTextStyle-submit',
          callback: function() {
            vm.resources.subTextStyle.defaultFamily = this.family;
            vm.element.internal_config.button.subTextStyle.family = this.family;

            vm.resources.subTextStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.button.subTextStyle.size = this.size + 'px';

            vm.resources.subTextStyle.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.button.subTextStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.subTextStyle.defaultColor = this.color;
            vm.element.internal_config.button.subTextStyle.color = this.color;

            vm.resources.subTextStyle.defaultAlign = this.align;
            vm.element.internal_config.button.subTextStyle.align = this.align;

            vm.resources.subTextStyle.defaultWeight = this.weight;
            vm.element.internal_config.button.subTextStyle.weight = this.weight;

            vm.resources.subTextStyle.defaultStyle = this.style;
            vm.element.internal_config.button.subTextStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        inputStyle: {
          name: 'inputStyle',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          labelDesc: 'inputStyle',
          callback: function() {
            vm.resources.inputStyle.defaultFamily = this.family;
            vm.element.internal_config.inputStyle.family = this.family;

            vm.resources.inputStyle.defaultSize = this.size + 'px';
            vm.element.internal_config.inputStyle.size = this.size + 'px';

            vm.resources.inputStyle.defaultColor = this.color;
            vm.element.internal_config.inputStyle.color = this.color;

            vm.resources.inputStyle.defaultAlign = this.align;
            vm.element.internal_config.inputStyle.align = this.align;

            vm.resources.inputStyle.defaultWeight = this.weight;
            vm.element.internal_config.inputStyle.weight = this.weight;

            vm.resources.inputStyle.defaultStyle = this.style;
            vm.element.internal_config.inputStyle.style = this.style;

            vm.element.inputStyle();
          }
        },
        padding: {
          name: 'padding',
          defaultLeft: '15',
          defaultTop: '15',
          defaultRight: '15',
          defaultBottom: '15',
          min: '0',
          max: '100',
          labelDesc: 'padding',
          callback: function() {
            vm.resources.padding.defaultLeft = this.l;
            vm.element.internal_config.paddingLeft = this.l + 'px';

            vm.resources.padding.defaultTop = this.t;
            vm.element.internal_config.paddingTop = this.t + 'px';

            vm.resources.padding.defaultRight = this.r;
            vm.element.internal_config.paddingRight = this.r + 'px';

            vm.resources.padding.defaultBottom = this.b;
            vm.element.internal_config.paddingBottom = this.b + 'px';

            vm.element.buildFields(vm.element);
          }
        },
        width: {
          name: 'width',
          defaultValue: '50',
          min: '20',
          max: '100',
          labelDesc: 'width-button-submit',
          callback: function() {
            vm.resources.width.defaultValue = this.value;
            vm.element.internal_config.button.width = this.value + '%';

            vm.element.buildFields(vm.element);
          }
        },
        height: {
          name: 'height',
          defaultValue: '50',
          min: '20',
          max: '100',
          labelDesc: 'height-button-submit',
          callback: function() {
            vm.resources.height.defaultValue = this.value;
            vm.element.internal_config.button.height = parseInt(this.value) + 'px';

            vm.element.buildFields(vm.element);
          }
        },
        //buttonNext
        widthNext: {
          name: 'widthNext',
          defaultValue: '50',
          min: '20',
          max: '100',
          labelDesc: 'next-width-button',
          callback: function() {
            vm.resources.widthNext.defaultValue = this.value;
            vm.element.internal_config.buttonNext.width = this.value + '%';

            vm.element.buildFields(vm.element);
          }
        },
        heightNext: {
          name: 'heightNext',
          defaultValue: '50',
          min: '20',
          max: '100',
          labelDesc: 'next-height-button',
          callback: function() {
            vm.resources.heightNext.defaultValue = this.value;
            vm.element.internal_config.buttonNext.height = parseInt(this.value) + 'px';

            vm.element.buildFields(vm.element);
          }
        },
        textNext: {
          name: 'textNext',
          defaultValue: '',
          labelDesc: 'next-text',
          canRemove: false,
          callback: function() {
            vm.resources.textNext.defaultValue = this.value;
            vm.element.internal_config.buttonNext.text = this.value;

            vm.element.internal_config.buttonNext.backgroundColor = vm.resources.backgroundColorNext.defaultValue;

            vm.element.buildFields(vm.element);
          }
        },
        subTextNext: {
          name: 'subTextNext',
          defaultValue: '',
          labelDesc: 'next-subtext',
          canRemove: false,
          callback: function() {
            vm.resources.subTextNext.defaultValue = this.value;
            vm.element.internal_config.buttonNext.subText = this.value;
            vm.element.internal_config.buttonNext.subText = this.value;

            vm.element.internal_config.buttonNext.backgroundColor = vm.resources.backgroundColorNext.defaultValue;

            vm.element.buildFields(vm.element);
          }
        },
        borderNext: {
          name: 'borderNext',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'next-border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.borderNext.defaultValue = value;
            vm.element.internal_config.buttonNext.border = value;

            vm.element.buildFields(vm.element);
          }
        },
        borderRadiusNext: {
          name: 'borderRadiusNext',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'next-borderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadiusNext.defaultValue = value;
            vm.element.internal_config.buttonNext.borderRadius = value;

            vm.element.buildFields(vm.element);
          }
        },
        boxShadowNext: {
          name: 'boxShadowNext',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'next-boxShadow',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            vm.resources.boxShadowNext.defaultValue = value;
            vm.element.internal_config.buttonNext.boxShadow = value;

            vm.element.buildFields(vm.element);
          }
        },
        backgroundColorNext: {
          name: 'backgroundColorNext',
          defaultValue: '#ffffff',
          labelDesc: 'next-bg-color',
          callback: function() {
            vm.resources.backgroundColorNext.defaultValue = this.colorValue;
            vm.element.internal_config.buttonNext.backgroundColor = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        backgroundColorHoverNext: {
          name: 'backgroundColorHoverNext',
          defaultValue: '#ffffff',
          labelDesc: 'next-bg-color-hover',
          callback: function() {
            vm.resources.backgroundColorHoverNext.defaultValue = this.colorValue;
            vm.element.internal_config.buttonNext.backgroundColorHover = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        textColorHoverNext: {
          name: 'textColorHoverNext',
          defaultValue: '#ffffff',
          labelDesc: 'next-bg-color-text-hover',
          callback: function() {
            vm.resources.textColorHoverNext.defaultValue = this.colorValue;
            vm.element.internal_config.buttonNext.textColorHover = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        textStyleNext: {
          name: 'textStyleNext',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'next-textStyle',
          callback: function() {
            vm.resources.textStyleNext.defaultFamily = this.family;
            vm.element.internal_config.buttonNext.textStyle.family = this.family;

            vm.resources.textStyleNext.defaultSize = this.size + 'px';
            vm.element.internal_config.buttonNext.textStyle.size = this.size + 'px';

            vm.resources.textStyleNext.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.buttonNext.textStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.textStyleNext.defaultColor = this.color;
            vm.element.internal_config.buttonNext.textStyle.color = this.color;

            vm.resources.textStyleNext.defaultAlign = this.align;
            vm.element.internal_config.buttonNext.textStyle.align = this.align;

            vm.resources.textStyleNext.defaultWeight = this.weight;
            vm.element.internal_config.buttonNext.textStyle.weight = this.weight;

            vm.resources.textStyleNext.defaultStyle = this.style;
            vm.element.internal_config.buttonNext.textStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        subTextStyleNext: {
          name: 'subTextStyleNext',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          labelDesc: 'next-subTextStyle',
          callback: function() {
            vm.resources.subTextStyleNext.defaultFamily = this.family;
            vm.element.internal_config.buttonNext.subTextStyle.family = this.family;

            vm.resources.subTextStyleNext.defaultSize = this.size + 'px';
            vm.element.internal_config.buttonNext.subTextStyle.size = this.size + 'px';

            vm.resources.subTextStyleNext.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.buttonNext.subTextStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.subTextStyleNext.defaultColor = this.color;
            vm.element.internal_config.buttonNext.subTextStyle.color = this.color;

            vm.resources.subTextStyleNext.defaultAlign = this.align;
            vm.element.internal_config.buttonNext.subTextStyle.align = this.align;

            vm.resources.subTextStyleNext.defaultWeight = this.weight;
            vm.element.internal_config.buttonNext.subTextStyle.weight = this.weight;

            vm.resources.subTextStyleNext.defaultStyle = this.style;
            vm.element.internal_config.buttonNext.subTextStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        iconNext: {
          name: 'iconNext',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'next-icon',
          callback: function() {
            vm.resources.iconNext.defaultIcon = this.iconSelected;
            vm.resources.iconNext.defaultPosition = this.position;

            vm.element.internal_config.buttonNext.icon = this.iconSelected;
            vm.element.internal_config.buttonNext.iconPosition = this.position;

            vm.element.buildIcon();
          }
        },
        //previousNext
        widthPrevious: {
          name: 'widthPrevious',
          defaultValue: '50',
          min: '20',
          max: '100',
          labelDesc: 'previous-width-button',
          callback: function() {
            vm.resources.widthPrevious.defaultValue = this.value;
            vm.element.internal_config.buttonPrevious.width = this.value + '%';

          }
        },
        heightPrevious: {
          name: 'heightPrevious',
          defaultValue: '50',
          min: '20',
          max: '100',
          labelDesc: 'previous-height-button',
          callback: function() {
            vm.resources.heightPrevious.defaultValue = this.value;
            vm.element.internal_config.buttonPrevious.height = parseInt(this.value) + 'px';

            vm.element.buildFields(vm.element);
          }
        },
        textPrevious: {
          name: 'textPrevious',
          defaultValue: '',
          labelDesc: 'previous-text',
          canRemove: false,
          callback: function() {
            vm.resources.textPrevious.defaultValue = this.value;
            vm.element.internal_config.buttonPrevious.text = this.value;

            vm.element.internal_config.buttonPrevious.backgroundColor = vm.resources.backgroundColorPrevious.defaultValue;

            vm.element.buildFields(vm.element);
          }
        },
        subTextPrevious: {
          name: 'subTextPrevious',
          defaultValue: '',
          labelDesc: 'previous-subtext',
          canRemove: false,
          callback: function() {
            vm.resources.subTextPrevious.defaultValue = this.value;
            vm.element.internal_config.buttonPrevious.subText = this.value;

            vm.element.internal_config.buttonPrevious.backgroundColor = vm.resources.backgroundColorPrevious.defaultValue;

            vm.element.buildFields(vm.element);
          }
        },
        borderPrevious: {
          name: 'borderPrevious',
          defaultValue: '1px solid black',
          min: '0',
          max: '50',
          labelDesc: 'previous-border',
          callback: function() {
            let value = this.value + 'px ' + this.value2 + ' ' + this.value3;

            vm.resources.borderPrevious.defaultValue = value;
            vm.element.internal_config.buttonPrevious.border = value;

            vm.element.buildFields(vm.element);
          }
        },
        borderRadiusPrevious: {
          name: 'borderRadiusPrevious',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'previous-borderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadiusPrevious.defaultValue = value;
            vm.element.internal_config.buttonPrevious.borderRadius = value;

            vm.element.buildFields(vm.element);
          }
        },
        boxShadowPrevious: {
          name: 'boxShadowPrevious',
          defaultValue: '0 0 0 0 black initial',
          min: '0',
          max: '50',
          labelDesc: 'previous-boxShadow',
          callback: function() {
            let value = this.h + 'px ' + this.v + 'px ' + this.b + 'px ' + this.s + 'px ' + this.colorValue + ' ' + (this.i === true ? 'inset' : '');

            vm.resources.boxShadowPrevious.defaultValue = value;
            vm.element.internal_config.buttonPrevious.boxShadow = value;

            vm.element.buildFields(vm.element);
          }
        },
        backgroundColorPrevious: {
          name: 'backgroundColorPrevious',
          defaultValue: '#ffffff',
          labelDesc: 'previous-bg-color',
          callback: function() {
            vm.resources.backgroundColorPrevious.defaultValue = this.colorValue;
            vm.element.internal_config.buttonPrevious.backgroundColor = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        backgroundColorHoverPrevious: {
          name: 'backgroundColorHoverPrevious',
          defaultValue: '#ffffff',
          labelDesc: 'previous-bg-color-hover',
          callback: function() {
            vm.resources.backgroundColorHoverPrevious.defaultValue = this.colorValue;
            vm.element.internal_config.buttonPrevious.backgroundColorHover = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        textColorHoverPrevious: {
          name: 'textColorHoverPrevious',
          defaultValue: '#ffffff',
          labelDesc: 'previous-bg-color-text-hover',
          callback: function() {
            vm.resources.textColorHoverPrevious.defaultValue = this.colorValue;
            vm.element.internal_config.buttonPrevious.textColorHover = this.colorValue;

            vm.element.buildFields(vm.element);
          }
        },
        textStylePrevious: {
          name: 'textStylePrevious',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          defaultWeight: '',
          defaultStyle: '',
          labelDesc: 'previous-textStyle',
          callback: function() {
            vm.resources.textStylePrevious.defaultFamily = this.family;
            vm.element.internal_config.buttonPrevious.textStyle.family = this.family;

            vm.resources.textStylePrevious.defaultSize = this.size + 'px';
            vm.element.internal_config.buttonPrevious.textStyle.size = this.size + 'px';

            vm.resources.textStylePrevious.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.buttonPrevious.textStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.textStylePrevious.defaultColor = this.color;
            vm.element.internal_config.buttonPrevious.textStyle.color = this.color;

            vm.resources.textStylePrevious.defaultAlign = this.align;
            vm.element.internal_config.buttonPrevious.textStyle.align = this.align;

            vm.resources.textStylePrevious.defaultWeight = this.weight;
            vm.element.internal_config.buttonPrevious.textStyle.weight = this.weight;

            vm.resources.textStylePrevious.defaultStyle = this.style;
            vm.element.internal_config.buttonPrevious.textStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        subTextStylePrevious: {
          name: 'subTextStylePrevious',
          showSizeMobile: true,
          defaultSizeMobile: '',
          defaultFamily: '',
          defaultSize: '',
          defaultColor: '',
          defaultAlign: '',
          labelDesc: 'previous-subTextStyle',
          callback: function() {
            vm.resources.subTextStylePrevious.defaultFamily = this.family;
            vm.element.internal_config.buttonPrevious.subTextStyle.family = this.family;

            vm.resources.subTextStylePrevious.defaultSize = this.size + 'px';
            vm.element.internal_config.buttonPrevious.subTextStyle.size = this.size + 'px';

            vm.resources.subTextStylePrevious.defaultSizeMobile = this.sizeMobile + 'px';
            vm.element.internal_config.buttonPrevious.subTextStyle.sizeMobile = this.sizeMobile + 'px';

            vm.resources.subTextStylePrevious.defaultColor = this.color;
            vm.element.internal_config.buttonPrevious.subTextStyle.color = this.color;

            vm.resources.subTextStylePrevious.defaultAlign = this.align;
            vm.element.internal_config.buttonPrevious.subTextStyle.align = this.align;

            vm.resources.subTextStylePrevious.defaultWeight = this.weight;
            vm.element.internal_config.buttonPrevious.subTextStyle.weight = this.weight;

            vm.resources.subTextStylePrevious.defaultStyle = this.style;
            vm.element.internal_config.buttonPrevious.subTextStyle.style = this.style;

            vm.element.buildFields(vm.element);
          }
        },
        iconPrevious: {
          name: 'iconPrevious',
          defaultIcon: '',
          defaultPosition: 'left',
          labelDesc: 'previous-icon',
          callback: function() {
            vm.resources.iconPrevious.defaultIcon = this.iconSelected;
            vm.resources.iconPrevious.defaultPosition = this.position;

            vm.element.internal_config.buttonPrevious.icon = this.iconSelected;
            vm.element.internal_config.buttonPrevious.iconPosition = this.position;

            vm.element.buildIcon();
          }
        },

        //navbar
        type: {
          name: 'type',
          defaultValue: 'number',
          options: [
            {
              name: 'none',
              value: 'none'
            },
            {
              name: 'number',
              value: 'number'
            },
            {
              name: 'icon',
              value: 'icon'
            }
          ],
          labelDesc: 'navbar-type',
          callback: function() {
            vm.resources.type.defaultValue = this.value;
            vm.element.internal_config.navBar.type = this.value;

            vm.element.buildProgressBar(vm.element);
          }
        },
        borderRadiusNav: {
          name: 'borderRadiusNav',
          defaultValue: '0 0 0 0',
          min: '0',
          max: '360',
          labelDesc: 'navbar-borderRadius',
          callback: function() {
            let value = this.v1 + 'px ' + this.v2 + 'px ' + this.v3 + 'px ' + this.v4 + 'px';

            vm.resources.borderRadiusNav.defaultValue = value;
            vm.element.internal_config.navBar.borderRadius = value;

            vm.element.buildProgressBar(vm.element);
          }
        },
        backgroundColorActiveNav: {
          name: 'backgroundColorActiveNav',
          defaultValue: '#ffffff',
          labelDesc: 'navbar-bg-color',
          callback: function() {
            vm.resources.backgroundColorActiveNav.defaultValue = this.colorValue;
            vm.element.internal_config.navBar.backgroundColorActive = this.colorValue;

            vm.element.buildProgressBar(vm.element);
          }
        },
        backgroundColorInactiveNav: {
          name: 'backgroundColorInactiveNav',
          defaultValue: '#ffffff',
          labelDesc: 'navbar-bg-color-inactive',
          callback: function() {
            vm.resources.backgroundColorInactiveNav.defaultValue = this.colorValue;
            vm.element.internal_config.navBar.backgroundColorInactive = this.colorValue;

            vm.element.buildProgressBar(vm.element);
          }
        },
        activeTextColorNav: {
          name: 'activeTextColorNav',
          defaultValue: '#ffffff',
          labelDesc: 'navbar-color',
          callback: function() {
            vm.resources.activeTextColorNav.defaultValue = this.colorValue;
            vm.element.internal_config.navBar.activeTextColor = this.colorValue;

            vm.element.buildProgressBar(vm.element);
          }
        },
        inactiveTextColorNav: {
          name: 'inactiveTextColorNav',
          defaultValue: '#ffffff',
          labelDesc: 'navbar-color-inactive',
          callback: function() {
            vm.resources.inactiveTextColorNav.defaultValue = this.colorValue;
            vm.element.internal_config.navBar.inactiveTextColor = this.colorValue;

            vm.element.buildProgressBar(vm.element);
          }
        },
        sizeNav: {
          name: 'size-nav',
          defaultValue: '12',
          min: '2',
          max: '20',
          labelDesc: 'size-nav',
          callback: function() {
            vm.resources.sizeNav.defaultValue = this.value;
            vm.element.internal_config.navBar.size = parseInt(this.value) + 'px';

            vm.element.buildProgressBar(vm.element);
          }
        },
        sizeTitleNav: {
          name: 'size-title-nav',
          defaultValue: '12',
          min: '2',
          max: '20',
          labelDesc: 'size-title-nav',
          callback: function() {
            vm.resources.sizeTitleNav.defaultValue = this.value;
            vm.element.internal_config.navBar.titleSize = parseInt(this.value) + 'px';

            vm.element.buildProgressBar(vm.element);
          }
        },
        titleTextColorNav: {
          name: 'color-title-nav',
          defaultValue: '#5B5B5BFF',
          labelDesc: 'color-title-nav',
          callback: function() {
            vm.resources.titleTextColorNav.defaultValue = this.colorValue;
            vm.element.internal_config.navBar.titleTextColor = this.colorValue;

            vm.element.buildProgressBar(vm.element);
          }
        },
        showTitleNav: {
          name: 'showTitleNav',
          defaultValue: '',
          labelDesc: 'show-title-nav',
          callback: function() {
            vm.resources.showTitleNav.defaultValue = this.value;
            vm.element.internal_config.navBar.showTitle = this.value;

            vm.element.buildProgressBar(vm.element);
          }
        },
      }
    };
  },
  methods: {
    setValuesData(data) {
      this.element = data;


      this.resources.maxWidth.defaultValue = parseInt(data.internal_config.maxWidth);

      // form
      this.resources.padding.defaultLeft = parseInt(data.internal_config.paddingLeft);
      this.resources.padding.defaultTop = parseInt(data.internal_config.paddingTop);
      this.resources.padding.defaultRight = parseInt(data.internal_config.paddingRight);
      this.resources.padding.defaultBottom = parseInt(data.internal_config.paddingBottom);

      // this.resources.horizontal.defaultValue = data.internal_config.horizontal;
      // input
      this.resources.inputColor.defaultValue = data.internal_config.inputBgColor;
      this.resources.labelStyle.defaultValue = data.internal_config.labelStyle;
      this.resources.placeholderColor.defaultValue = data.internal_config.placeholderColor;
      this.resources.inputBorder.defaultValue = data.internal_config.inputBorder;
      this.resources.inputHeight.defaultValue = data.internal_config.inputHeight;
      if (!data.internal_config.textareaHeight) {
        this.$nextTick(() => {
          let textareaHeightNumber = $(data.$el).find('textarea.form-control:visible').outerHeight();
          this.resources.textareaHeight.defaultValue = (textareaHeightNumber || 54) + 'px';
        });
      } else
        this.resources.textareaHeight.defaultValue = data.internal_config.textareaHeight;

      this.resources.buttonMargin.defaultValue = data.internal_config.button.margin;
      this.resources.inputRadius.defaultValue = data.internal_config.inputRadius;

      this.resources.inputStyle.defaultFamily = data.internal_config.inputStyle.family;
      this.resources.inputStyle.defaultSize = data.internal_config.inputStyle.size;
      this.resources.inputStyle.defaultColor = data.internal_config.inputStyle.color;
      this.resources.inputStyle.defaultAlign = data.internal_config.inputStyle.align;
      this.resources.inputStyle.defaultWeight = data.internal_config.inputStyle.weight;
      this.resources.inputStyle.defaultStyle = data.internal_config.inputStyle.style;

      // button
      this.resources.width.defaultValue = parseInt(data.internal_config.button.width);
      this.resources.height.defaultValue = parseInt(data.internal_config.button.height);

      this.resources.text.defaultValue = data.internal_config.button.text;
      this.resources.subText.defaultValue = data.internal_config.button.subText;

      this.resources.border.defaultValue = data.internal_config.button.border;
      this.resources.borderRadius.defaultValue = data.internal_config.button.borderRadius;
      this.resources.boxShadow.defaultValue = data.internal_config.button.boxShadow;

      this.resources.backgroundColor.defaultValue = data.internal_config.button.backgroundColor;
      this.resources.backgroundColorHover.defaultValue = data.internal_config.button.backgroundColorHover;
      this.resources.textColorHover.defaultValue = data.internal_config.button.textColorHover;

      this.resources.textStyle.defaultFamily = data.internal_config.button.textStyle.family;
      this.resources.textStyle.defaultSize = data.internal_config.button.textStyle.size;
      this.resources.textStyle.defaultSizeMobile = data.internal_config.button.textStyle.sizeMobile;
      this.resources.textStyle.defaultColor = data.internal_config.button.textStyle.color;
      this.resources.textStyle.defaultAlign = data.internal_config.button.textStyle.align;
      this.resources.textStyle.defaultWeight = data.internal_config.button.textStyle.weight;
      this.resources.textStyle.defaultStyle = data.internal_config.button.textStyle.style;


      this.resources.subTextStyle.defaultFamily = data.internal_config.button.subTextStyle.family;
      this.resources.subTextStyle.defaultSize = data.internal_config.button.subTextStyle.size;
      this.resources.subTextStyle.defaultSizeMobile = data.internal_config.button.subTextStyle.sizeMobile;
      this.resources.subTextStyle.defaultColor = data.internal_config.button.subTextStyle.color;
      this.resources.subTextStyle.defaultAlign = data.internal_config.button.subTextStyle.align;
      this.resources.subTextStyle.defaultWeight = data.internal_config.button.subTextStyle.weight;
      this.resources.subTextStyle.defaultStyle = data.internal_config.button.subTextStyle.style;

      this.resources.icon.defaultIcon = data.internal_config.button.icon;
      this.resources.icon.defaultPosition = data.internal_config.button.iconPosition;

      //next-button
      this.resources.widthNext.defaultValue = parseInt(data.internal_config.buttonNext.width);
      this.resources.heightNext.defaultValue = parseInt(data.internal_config.buttonNext.height);

      this.resources.textNext.defaultValue = data.internal_config.buttonNext.text;
      this.resources.subTextNext.defaultValue = data.internal_config.buttonNext.subText;

      this.resources.borderNext.defaultValue = data.internal_config.buttonNext.border;
      this.resources.borderRadiusNext.defaultValue = data.internal_config.buttonNext.borderRadius;
      this.resources.boxShadowNext.defaultValue = data.internal_config.buttonNext.boxShadow;

      this.resources.backgroundColorNext.defaultValue = data.internal_config.buttonNext.backgroundColor;
      this.resources.backgroundColorHoverNext.defaultValue = data.internal_config.buttonNext.backgroundColorHover;
      this.resources.textColorHoverNext.defaultValue = data.internal_config.buttonNext.textColorHover;

      this.resources.textStyleNext.defaultFamily = data.internal_config.buttonNext.textStyle.family;
      this.resources.textStyleNext.defaultSize = data.internal_config.buttonNext.textStyle.size;
      this.resources.textStyleNext.defaultSizeMobile = data.internal_config.buttonNext.textStyle.sizeMobile;
      this.resources.textStyleNext.defaultColor = data.internal_config.buttonNext.textStyle.color;
      this.resources.textStyleNext.defaultAlign = data.internal_config.buttonNext.textStyle.align;
      this.resources.textStyleNext.defaultWeight = data.internal_config.buttonNext.textStyle.weight;
      this.resources.textStyleNext.defaultStyle = data.internal_config.buttonNext.textStyle.style;


      this.resources.subTextStyleNext.defaultFamily = data.internal_config.buttonNext.subTextStyle.family;
      this.resources.subTextStyleNext.defaultSize = data.internal_config.buttonNext.subTextStyle.size;
      this.resources.subTextStyleNext.defaultSizeMobile = data.internal_config.buttonNext.subTextStyle.sizeMobile;
      this.resources.subTextStyleNext.defaultColor = data.internal_config.buttonNext.subTextStyle.color;
      this.resources.subTextStyleNext.defaultAlign = data.internal_config.buttonNext.subTextStyle.align;
      this.resources.subTextStyleNext.defaultWeight = data.internal_config.buttonNext.subTextStyle.weight;
      this.resources.subTextStyleNext.defaultStyle = data.internal_config.buttonNext.subTextStyle.style;

      this.resources.iconNext.defaultIcon = data.internal_config.buttonNext.icon;
      this.resources.iconNext.defaultPosition = data.internal_config.buttonNext.iconPosition;
      //previous-button
      this.resources.widthPrevious.defaultValue = parseInt(data.internal_config.buttonPrevious.width);
      this.resources.heightPrevious.defaultValue = parseInt(data.internal_config.buttonPrevious.height);

      this.resources.textPrevious.defaultValue = data.internal_config.buttonPrevious.text;
      this.resources.subTextPrevious.defaultValue = data.internal_config.buttonPrevious.subText;

      this.resources.borderPrevious.defaultValue = data.internal_config.buttonPrevious.border;
      this.resources.borderRadiusPrevious.defaultValue = data.internal_config.buttonPrevious.borderRadius;
      this.resources.boxShadowPrevious.defaultValue = data.internal_config.buttonPrevious.boxShadow;

      this.resources.backgroundColorPrevious.defaultValue = data.internal_config.buttonPrevious.backgroundColor;
      this.resources.backgroundColorHoverPrevious.defaultValue = data.internal_config.buttonPrevious.backgroundColorHover;
      this.resources.textColorHoverPrevious.defaultValue = data.internal_config.buttonPrevious.textColorHover;

      this.resources.textStylePrevious.defaultFamily = data.internal_config.buttonPrevious.textStyle.family;
      this.resources.textStylePrevious.defaultSize = data.internal_config.buttonPrevious.textStyle.size;
      this.resources.textStylePrevious.defaultSizeMobile = data.internal_config.buttonPrevious.textStyle.sizeMobile;
      this.resources.textStylePrevious.defaultColor = data.internal_config.buttonPrevious.textStyle.color;
      this.resources.textStylePrevious.defaultAlign = data.internal_config.buttonPrevious.textStyle.align;
      this.resources.textStylePrevious.defaultWeight = data.internal_config.buttonPrevious.textStyle.weight;
      this.resources.textStylePrevious.defaultStyle = data.internal_config.buttonPrevious.textStyle.style;


      this.resources.subTextStylePrevious.defaultFamily = data.internal_config.buttonPrevious.subTextStyle.family;
      this.resources.subTextStylePrevious.defaultSize = data.internal_config.buttonPrevious.subTextStyle.size;
      this.resources.subTextStylePrevious.defaultSizeMobile = data.internal_config.buttonPrevious.subTextStyle.sizeMobile;
      this.resources.subTextStylePrevious.defaultColor = data.internal_config.buttonPrevious.subTextStyle.color;
      this.resources.subTextStylePrevious.defaultAlign = data.internal_config.buttonPrevious.subTextStyle.align;
      this.resources.subTextStylePrevious.defaultWeight = data.internal_config.buttonPrevious.subTextStyle.weight;
      this.resources.subTextStylePrevious.defaultStyle = data.internal_config.buttonPrevious.subTextStyle.style;

      this.resources.iconPrevious.defaultIcon = data.internal_config.buttonPrevious.icon;
      this.resources.iconPrevious.defaultPosition = data.internal_config.buttonPrevious.iconPosition;


      this.resources.titleFormStyle.defaultFamily = data.internal_config.titleFormStyle.family;
      this.resources.titleFormStyle.defaultSize = data.internal_config.titleFormStyle.size;
      this.resources.titleFormStyle.defaultSizeMobile = data.internal_config.titleFormStyle.sizeMobile;
      this.resources.titleFormStyle.defaultColor = data.internal_config.titleFormStyle.color;
      this.resources.titleFormStyle.defaultAlign = data.internal_config.titleFormStyle.align;
      this.resources.titleFormStyle.defaultWeight = data.internal_config.titleFormStyle.weight;
      this.resources.titleFormStyle.defaultStyle = data.internal_config.titleFormStyle.style;

      this.resources.descriptionFormStyle.defaultFamily = data.internal_config.descriptionFormStyle.family;
      this.resources.descriptionFormStyle.defaultSize = data.internal_config.descriptionFormStyle.size;
      this.resources.descriptionFormStyle.defaultSizeMobile = data.internal_config.descriptionFormStyle.sizeMobile;
      this.resources.descriptionFormStyle.defaultColor = data.internal_config.descriptionFormStyle.color;
      this.resources.descriptionFormStyle.defaultAlign = data.internal_config.descriptionFormStyle.align;
      this.resources.descriptionFormStyle.defaultWeight = data.internal_config.descriptionFormStyle.weight;
      this.resources.descriptionFormStyle.defaultStyle = data.internal_config.descriptionFormStyle.style;

      this.resources.showLabel.defaultValue = data.internal_config.showLabel;
      this.resources.showTitle.defaultValue = data.internal_config.form.showTitle;
      this.resources.showDescription.defaultValue = data.internal_config.form.showDescription;
      this.resources.showPreviousButton.defaultValue = data.internal_config.form.showPreviousButton;
      this.resources.showPlaceholder.defaultValue = data.internal_config.showPlaceholder;

      //navbar
      this.resources.type.defaultValue = data.internal_config.navBar.type;
      this.resources.borderRadiusNav.defaultValue = data.internal_config.navBar.borderRadius;
      this.resources.backgroundColorActiveNav.defaultValue = data.internal_config.navBar.backgroundColorActive;
      this.resources.backgroundColorInactiveNav.defaultValue = data.internal_config.navBar.backgroundColorInactive;
      this.resources.activeTextColorNav.defaultValue = data.internal_config.navBar.activeTextColor;
      this.resources.inactiveTextColorNav.defaultValue = data.internal_config.navBar.inactiveTextColor;
      this.resources.titleTextColorNav.defaultValue = data.internal_config.navBar.titleTextColor;
      this.resources.sizeNav.defaultValue = data.internal_config.navBar.size;
      this.resources.sizeTitleNav.defaultValue = data.internal_config.navBar.titleSize;
      this.resources.showTitleNav.defaultValue = data.internal_config.navBar.showTitle;

    },
    getValuesData() {
      return this.resources;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/editor/apps/Forms/MultiStepForm/Resources.vue